import { render, staticRenderFns } from "./PlayerStatus.vue?vue&type=template&id=2082a071&scoped=true"
import script from "./PlayerStatus.vue?vue&type=script&lang=js"
export * from "./PlayerStatus.vue?vue&type=script&lang=js"
import style0 from "./PlayerStatus.vue?vue&type=style&index=0&id=2082a071&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2082a071",
  null
  
)

export default component.exports